import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getAgendas(currentPage) {
    return httpAdminClient.get(`admin/meeting/agendas?page=${currentPage}&per_page=10`);
  },
  cancelAppointment(id, data) {
    return httpAdminClient.post(`admin/meeting/appointments/${id}/handle`, { meeting_appointment: { reserves: data } });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/meeting/agendasApis.js